{
  "buildId": 1744097645,
  "integrations": {
    "bazaarvoice": {
      "env": "production",
      "user": "pg-oralbfrance_fr",
      "loader": "main_site_new"
    },
    "syndigo": {
      "site_id": "5a02b433-9999-42d1-8809-698bda3356b6"
    },
    "jebbitId": "65u8GeteU18iBVyVM8fK28",
    "c360": {
      "newsletter_selection": {
        "enabled": true,
        "title": "Dites-nous quel type de brosse à dents vous utilisez actuellement?",
        "selections": [
          {
            "image": "assets/images/newsletter/Manual.png",
            "text": "Brosse à Dents Manuelle",
            "value": "Manuelle"
          },
          {
            "image": "assets/images/newsletter/iO-ETB.png",
            "text": "Brosse à Dents Électrique Oral-B",
            "value": "Oral-B iO"
          },
          {
            "image": "assets/images/newsletter/OR-ETB.png",
            "text": " Oral-B Series iO",
            "value": " Oral-B Series iO"
          },
          {
            "image": "assets/images/newsletter/Other-Brand.png",
            "text": "Autre Marque Brosse à Dents Électrique",
            "value": "Autre Marque Brosse à Dents Électrique"
          }
        ]
      }
    }
  },
  "GTM": {
    "env": "",
    "SiteTouchpoint": "49599",
    "SiteLocalContainer": "GTM-PVL3929T",
    "GoogleAnalyticsGA4MeasurementID": "G-TTVEVJRR3L",
    "ConsentOverlayID": "htmllang/6eca7417-dd3e-4a1b-9cff-a361fc9070ca"
  },
  "seo": {
    "store": "Oral-B",
    "og_image": "https://cdn-prod.scalefast.com/public/assets/themes/oral-b-es/images/oralb-og.png",
    "tw_image": "https://cdn-prod.scalefast.com/public/assets/themes/oral-b-es/images/oralb-twitter.png",
    "pages": {
      "404": {
        "title": "Page introuvable",
        "desc": "La page que vous cherchiez semble avoir été déplacée, supprimée ou n'existe pas."
      },
      "search": {
        "title": "Résultats de la recherche",
        "desc": "Résultats de la recherche"
      },
      "cgv": {
        "title": "Conditions générales d'utilisation",
        "desc": ""
      },
      "rp": {
        "title": "Politique de retour et droit de rétractation",
        "desc": ""
      },
      "privacy": {
        "title": "Politique de confidentialité et de cookies",
        "desc": ""
      }
    },
    "homepage_title": "Brosses à dents électriques, soin et santé dentaire",
    "desc": "Parcourez les brosses à dents manuelles et électriques d'Oral-B et découvrez tous les secrets pour conserver une bonne hygiène bucco-dentaire."
  },
  "disableThirdPartyScripts": "false",
  "hybridV4Paths": [
    "/account",
    "/cart",
    "/login",
    "/payment",
    "/reset-password",
    "/support",
    "/warranty",
    "/product-popup",
    "/sso_"
  ],
  "contentful": {
    "blocklist": {
      "enabled": true,
      "slugs": [
        "/fr-fr/big-rethink",
        "/fr-fr/produits-dentaires/iscc-plastique-biosource",
        "/fr-fr/produits-dentaires/dentifrice-composition",
        "/fr-fr/sante-bucco-dentaire-developpement-durable",
        "/fr-fr/votre-sante-generale",
        "/fr-fr/produits-dentaires/brosse-a-dent-oral-b-genius-x",
        "/fr-fr/produits-dentaires/application-dentaire",
        "/fr-fr/produits-dentaires/brosse-a-dent-nouvelle-technologie",
        "/fr-fr/produits-dentaires/sante-bucco-dentaire-enfant",
        "/fr-fr/produits-dentaires/application-disney-magic",
        "/fr-fr/produits-dentaires/conseils-d-hygiene-bucco-dentaire",
        "/fr-fr/offres-et-nouveautes",
        "/fr-fr/nous-contacter",
        "/fr-fr/MaMeilleureBrosse",
        "/fr-fr/loginpage",
        "/fr-fr/create-profile",
        "/fr-fr/besoins/tartre-plaque-dentaire",
        "/fr-fr/besoins/sensibilite-dentaire",
        "/fr-fr/besoins/protection-des-gencives",
        "/fr-fr/besoins/mauvaise-haleine",
        "/fr-fr/besoins/email-dentaire",
        "/fr-fr/besoins/des-dents-fortes",
        "/fr-fr/besoins/caries",
        "/fr-fr/besoins/blanchiment",
        "/fr-fr/besoins/bagues-et-appareils-orthodontiques",
        "/fr-fr/search",
        "/fr-fr/sitemap",
        "/fr-fr/spotlight",
        "/fr-fr/guide-de-demarrage/brosse",
        "/fr-fr/sante-bucco-dentaire/pourquoi-choisir-oral-b/dentifrices/dentifrice-au-carbon",
        "/fr-fr/recommendedbrush",
        "/fr-fr/rejoindre-la-liste-d-attente-oralb-io10",
        "/fr-fr/MabrosseOral-B",
        "/fr-fr/collection/floss",
        "/fr-fr/conditions/dry-mouth",
        "/fr-fr/battery-toothbrushes",
        "/fr-fr/confirmer-produit",
        "/fr-fr/register-products",
        "/fr-fr/change-password",
        "/fr-fr/congratulations",
        "/fr-fr/register-product",
        "/fr-fr/profile",
        "/fr-fr/sante-bucco-dentaire/pourquoi-choisir-oral-b/produits",
        "/fr-fr/oral-health/why-oral-b/why-floss-old",
        "/fr-fr/resetpasswordpage",
        "/fr-fr/forgot-password",
        "/fr-fr/cavities-tooth-decay",
        "/fr-fr/white-strips"
      ]
    }
  },
  "dotPathsEnabled": false,
  "hideCrossedPrice": true,
  "offerFeed": "71671",
  "bundleCrossedPriceIsRecommendedPrice": false,
  "freeShippingValue": 69.99,
  "freeShippingFeeds": [
    71611,
    71663,
    72895
  ],
  "helpUrl": {
    "contact": "https://oral-bshop.zendesk.com/hc/fr",
    "service": "https://www.service.oralb.com/fr/fr/"
  },
  "pohFeeds": [
    71611,
    71663
  ],
  "pohUrl": "/poh_fr",
  "showFromInMetaProductPrices": true,
  "showPricesOnComparisonProducts": true,
  "newsletterTrackers": {
    "newsletter-footer": "OralB_footerEmail",
    "newsletter-modal": "OralB_popup"
  }
}